export default __webpack_public_path__ + "static/media/home-category-whitening-care-temporary.7aae398b.jpg";